import { useInfiniteQuery } from '@tanstack/react-query';

import { type Account, type QueryAccountsAllByUserIdArgs } from '@app/graphql/codegen/graphql';

import { callGetConnectedWalletsByUser } from './request';

export const USER_WALLETS_CACHE = 'connected-wallets-query';
export const USER_WALLETS_BY_USER_CACHE = 'connected-wallets-by-user-query';
const DEFAULT_LIMIT = 100;

// Limit can be between 50 and 500
export function useWalletsQueryById(variables: QueryAccountsAllByUserIdArgs) {
    return useInfiniteQuery(
        [USER_WALLETS_BY_USER_CACHE, USER_WALLETS_CACHE, variables.userId],
        ({ signal, pageParam }) =>
            callGetConnectedWalletsByUser({
                variables: {
                    ...variables,
                    cursorInput: { limit: variables.cursorInput?.limit || DEFAULT_LIMIT, cursor: pageParam },
                },
                settings: { signal },
            }),
        {
            getNextPageParam: (data) => {
                if (data) {
                    return data.cursor;
                }
            },
            select: (data) => {
                const pages = data?.pages.reduce<Array<Account>>((accumulator, current) => {
                    if (current) {
                        return [...accumulator, current.accounts].flat();
                    }
                    return accumulator;
                }, []);
                return {
                    pages,
                    pageParams: data.pageParams,
                };
            },
            retry: true,
            keepPreviousData: true,
            enabled: !!variables.userId,
        },
    );
}
